module.exports = __webpack_public_path__ + "img/kuwait-6.02548b73.jpg";